import QuickPanel from 'app/fuse-layouts/shared-components/quickPanel/QuickPanel';
import React from 'react';

function RightSideLayoutFinanceiro() {
  return (
    <>
      <QuickPanel />
    </>
  );
}

export default RightSideLayoutFinanceiro;
